const signaturesUserReducer = (userId = 0, action) => {
    switch(action.type){
        case 'CHANGE_SIGNATURES_USER':
            userId = action.data;
            return userId;
        default:
            return userId;
    }
}

export default signaturesUserReducer;